// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2XosO{background:#000;color:#fff;font-size:8pt;letter-spacing:.08em;line-height:.25in;padding:0 .1in;text-transform:uppercase;width:100%}", ""]);
// Exports
exports.locals = {
	"sectionTitle": "_2XosO"
};
module.exports = exports;
